export default "__VITE_ASSET__TCc3de9y__"